"use strict";

angular.module('PatientApp').factory('PaymentPlansService', function (VuexStore) {
  return {
    fetchPaymentPlanDetails: function fetchPaymentPlanDetails(planId) {
      return VuexStore.dispatch('fetchPaymentPlanDetails', planId);
    },
    updatePaymentForm: function updatePaymentForm(planId, paymentFormId) {
      return VuexStore.dispatch('updatePaymentForm', {
        planId: planId,
        paymentFormId: paymentFormId
      });
    }
  };
});